<template>
  <div class="ticket-raffles">
    <info-box v-bind:description="description"></info-box>
    <header-title title="TICKET RAFFLES" />
    <transition-group v-bind:name="gotInitialRaffles > 1 ? 'raffles-list' : ''" mode="out-in">
      <ticket-raffle
        v-for="ticketRaffleId in currentTicketRaffleIds"
        v-bind:ticketRaffleId="ticketRaffleId"
        :key="ticketRaffleId"
      ></ticket-raffle>
    </transition-group>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'ticket-raffles',
  async created () {
    await this.refreshTicketRaffles()
  },
  data () {
    return {
      gotInitialRaffles: 0,
      description: {
        title: 'Ticket Raffles',
        text: `New raffles will be displayed here, You can buy tickets to enter an open raffle by clicking on the raffle and entering an amount then clicking "Buy Tickets", If you want to buy tickets in chat, type the KEYWORD (without !) and the # of tickets you want - you don’t need to be here if you win, you’ll get whispered your prize or info`
      }
    }
  },
  computed: Object.assign(mapState([
    'currentTicketRaffleIds'
  ]), {

  }),
  watch: {
    currentTicketRaffleIds: function () {
      this.gotInitialRaffles += 1
    }
  },
  methods: {
    async refreshTicketRaffles () {
      this.$store.dispatch('fetchCurrentTicketRaffles')
      this.$store.dispatch('fetchMyTickets')
    }
  }
}
</script>

<style scoped>
.raffles-list-enter-active,
.raffles-list-leave-active {
  transition: background-color 0.2s;
}
.raffles-list-enter,
.raffles-list-leave-to {
  background-color: #fcc9fc;
}
</style>


// WEBPACK FOOTER //
// src/components/Ticket-Raffles.vue